module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-logo@2x__e20f1737ee67fbe8e9ef4d56df63b6e8.png";